import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ProjectInvitaionData } from '../../../types';
import { DaslockTask } from '../../../types/Device';

type NotificationState = {
  invitations: ProjectInvitaionData[];
  dasLockTaskGroups: DaslockTask[];
  count: number;
};

const initialState: NotificationState = {
  invitations: [],
  dasLockTaskGroups: [],
  count: 0,
};

export const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    setInvitations: (state, action: PayloadAction<ProjectInvitaionData[]>) => {
      return {
        ...state,
        invitations: action.payload,
      };
    },
    setDasLockTaskGroups: (state, action: PayloadAction<DaslockTask[]>) => {
      return {
        ...state,
        dasLockTaskGroups: action.payload,
      };
    },
    setCount: (state, action: PayloadAction<number>) => {
      return {
        ...state,
        count: action.payload,
      };
    },
  },
});

export const { setInvitations, setDasLockTaskGroups, setCount } =
  notificationSlice.actions;
export default notificationSlice.reducer;
